import { render, staticRenderFns } from "./DetalheMovimentacoes.vue?vue&type=template&id=2f1954d2&scoped=true&"
import script from "./DetalheMovimentacoes.vue?vue&type=script&lang=js&"
export * from "./DetalheMovimentacoes.vue?vue&type=script&lang=js&"
import style0 from "./DetalheMovimentacoes.vue?vue&type=style&index=0&id=2f1954d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1954d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\06.04\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f1954d2')) {
      api.createRecord('2f1954d2', component.options)
    } else {
      api.reload('2f1954d2', component.options)
    }
    module.hot.accept("./DetalheMovimentacoes.vue?vue&type=template&id=2f1954d2&scoped=true&", function () {
      api.rerender('2f1954d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Materiais/DetalheMovimentacoes.vue"
export default component.exports